import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSchoolFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.24101 12.6421V16.124C5.24101 17.3243 5.8418 18.4435 6.83953 19.1074L8.44661 20.1764C10.5991 21.6077 13.4007 21.6079 15.5524 20.1764L17.1591 19.1076C18.1585 18.4433 18.758 17.3226 18.758 16.124V12.6426L14.6613 14.9186C13.006 15.8372 10.9934 15.8375 9.33891 14.9187L5.24101 12.6421Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.223 3.55836C12.8399 2.81388 11.1601 2.81388 9.77702 3.55836L2.67591 7.38593C1.77466 7.87164 1.77471 9.12839 2.67596 9.6141L9.77702 13.4416C11.1589 14.1861 12.8401 14.1862 14.2233 13.4414L21.3241 9.61407C22.2253 9.12837 22.2253 7.87161 21.324 7.38591L14.223 3.55836Z",
		fill: "#111827"
	})]
});
const ForwardRef = forwardRef(SvgSchoolFilled);
export default ForwardRef;
